import { useEffect } from 'react';
import { EPIC_FIELD_KEYS } from '../_const';
import AppWrappedCheckbox from '../AppWrappedCheckbox';

const SchedulingRoleCheckbox = ({ ...props }) => {
	// If the default department changes, reset the value
	useEffect(() => {
		props.formik?.setFieldValue(props.name, false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.formik.values[EPIC_FIELD_KEYS.SCHEDULING_ROLE]]);

	return (
		<AppWrappedCheckbox name={props.name} label='' formik={props.formik} />
	);
};

export default SchedulingRoleCheckbox;
